import { api } from '@/services/axios'

export interface GetCampaignsPrazoResponse {
  id: number
  descricao: string
  minutos: number
}

export async function getCampaignsPrazo(): Promise<
  GetCampaignsPrazoResponse[]
> {
  const response = await api.get<GetCampaignsPrazoResponse[]>(`Campanha/prazos`)
  return response.data
}
